import { ChangeDetectionStrategy, Component, computed, effect } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MdsIconButtonComponent } from '@medpacesoftwaredevelopment/designsystem';
import { StudyExpenseTrackingDataRow } from '@models/studyExpenseTrackingDataRow';
import { BaseCellEditorComponent } from '../base-cell-editor/base-cell-editor.component';
@Component({
    selector: 'app-custom-cell-editor-button',
    imports: [MdsIconButtonComponent],
    standalone: true,
    templateUrl: './custom-cell-editor-button.component.html',
    styleUrl: './custom-cell-editor-button.component.scss',

    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCellEditorButtonComponent<TValue, TContext = any> extends BaseCellEditorComponent<
    StudyExpenseTrackingDataRow,
    TValue,
    TContext,
    { values: TValue[] }
> {
    public params: any;
    formControl = new FormControl<TValue | null>(null);
    setInitialValue = effect(() => {
        const baseParams = this.baseParams();

        if (!baseParams || baseParams.value === undefined) return; // this.formControl.setValue(undefined); will cause MDS errors ;__;
        this.formControl.setValue(baseParams.value);
    });

    agInit(params: any): void {
        this.params = params;
    }

    selectAllText = computed(() => {
        const baseParams = this.baseParams();
        if (!baseParams) return '';
        return baseParams.formatValue(this.formControl.value);
    });

    getValue(): TValue {
        return this.formControl.value;
    }
    save() {
        this.baseParams().api.stopEditing(false);
    }

    click() {
        this.params.icon === 'add'
            ? this.params.onClickAdd(this.params.node)
            : this.params.onClickRemove(this.params.node);
    }
}
